import React from 'react';
import Svg, { Circle } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function More({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Circle cx="12" cy="6" r="2" fill={iconColor} />
      <Circle cx="12" cy="12" r="2" fill={iconColor} />
      <Circle cx="12" cy="18" r="2" fill={iconColor} />
    </Svg>
  );
}
